export const COOKIE_KEYS = {
  token: "token",
  refreshToken: "refreshToken",
};
